import request from '@/utils/requests.js'

// Doctor API Services
export const doctorService = {
  // Exam Management
  async getExamsForReview(params = {}) {
    return request({
      url: '/doctor/exams',
      method: 'get',
      params
    })
  },

  async getExamById(examId) {
    return request({
      url: `/doctor/exams/${examId}`,
      method: 'get'
    })
  },

  // Report Management
  async createReport(reportData) {
    return request({
      url: '/doctor/reports',
      method: 'post',
      data: reportData
    })
  },

  async updateReport(reportId, reportData) {
    return request({
      url: `/doctor/reports/${reportId}`,
      method: 'put',
      data: reportData
    })
  },

  async signReport(reportId, signatureData) {
    return request({
      url: `/doctor/reports/${reportId}/sign`,
      method: 'post',
      data: signatureData
    })
  },

  async getReportsToSign() {
    return request({
      url: '/doctor/reports/pending-signature',
      method: 'get'
    })
  },

  // Dashboard metrics for doctors
  getDashboardMetrics() {
    return request({
      url: '/doctor/metrics',
      method: 'get'
    });
  },

  getPendingExams() {
    return request({
      url: '/doctor/exams/pending',
      method: 'get'
    });
  },

  getWeeklyStats() {
    return request({
      url: '/doctor/stats/weekly',
      method: 'get'
    });
  },

  getPriorityExams() {
    return request({
      url: '/doctor/exams/priority',
      method: 'get'
    });
  },

  getRecentActivity() {
    return request({
      url: '/doctor/activity/recent',
      method: 'get'
    });
  },

  // Quick actions
  markExamUrgent(examId) {
    return request({
      url: `/doctor/exams/${examId}/urgent`,
      method: 'post'
    });
  },

  requestConsultation(examId, consultantId) {
    return request({
      url: `/doctor/exams/${examId}/consultation`,
      method: 'post',
      data: { consultantId }
    });
  }
}
